"use strict";
import ViewBase from "../view-base.view";
import SelectSiteComponent from "../../components/site/select-site.component";
import SelectSiteGroupComponent from "../../components/site/select-site-group.component";
import SelectUserComponent from "../../components/user/select-user.component";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import surveyModel from "../../models/survey/survey.model";
import moment from "moment";
import { formats as FORMATS } from '../../config/constants';

export default function ExportQuickSurveyView() {

  ViewBase.call(this);

  let survey;
  let selectedSiteList = [];
  let selectedSiteGroupList = [];
  let selectedUserList = [];
  let isDownloadingExcel = false;
  let isDownloadingPpt = false;
  let filter = {
    surveyId: "",
    siteId: "",
    siteGroupId: "",
    userId: "",
    surveyStartDate: "",
    surveyEndDate: ""
  }

  let closeModal = function () { }

  const extractFilterToQueryParams = () => {
    return Object.assign(
      {},
      filter,
      {
        surveyStartDate: filter.surveyStartDate ? moment(filter.surveyStartDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat) : '',
        surveyEndDate: filter.surveyEndDate ? moment(filter.surveyEndDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat) : ''
      },
    );
  }

  let _downloadExcel = (e) => {
    e.preventDefault();
    if (isDownloadingExcel) {
      return false;
    }
    isDownloadingExcel = true;
    surveyModel.exportSurveyToExcel(
      (result) => {
        isDownloadingExcel = false;
      },
      (error) => {
        isDownloadingExcel = false;
        this.handleError(error);
      },
      extractFilterToQueryParams(),
      'Quick Survey' + (survey?.title ? ` - ${survey.title}` : '') + ` - ${moment().format('YYYYMMDDHHmm')}.xlsx`
    );
    return false;
  }

  let _downloadPPT = (e) => {
    e.preventDefault();
    if (isDownloadingPpt) {
      return false;
    }
    isDownloadingPpt = true;
    surveyModel.exportSurveyToPptx(
      (result) => {
        isDownloadingPpt = false;
      },
      (error) => {
        isDownloadingPpt = false;
        this.handleError(error);
      },
      extractFilterToQueryParams(),
      'Quick Survey' + (survey?.title ? ` - ${survey.title}` : '') + ` - ${moment().format('YYYYMMDDHHmm')}.zip`
    );
    return false;
  }

  return {
    oninit: (vnode) => {
      if (typeof vnode.attrs.closeModal === 'function') {
        closeModal = vnode.attrs.closeModal;
      }
      if (vnode.attrs.data) {
        survey = vnode.attrs.data;
        filter.surveyId = survey.surveyId;
      }
    },
    view: (vnode) => {
      return m('.container',
        m('.row.g-3',
          m('.col-12',
            m('label.form-label[for=period]', this.getText("LT00000150", "Period")),
            m(DatePickerComponent, {
              class: 'form-control',
              isRange: true,
              grid: 1,
              calendars: 1,
              dateStart: filter.surveyStartDate, // default date range
              dateEnd: filter.surveyEndDate, // default date range
              minDate: survey.fromDate || '',
              maxDate: survey.toDate || '',
              readonly: true,
              onselect: (e) => {
                filter.surveyStartDate = moment(e.detail.start).format(FORMATS.dateFormat);
                filter.surveyEndDate = moment(e.detail.end).format(FORMATS.dateFormat);
              }
            })
          ),
          m('.col-12',
            m('label.form-label', this.getText("LT00000516", "Site(s)")),
            m(SelectSiteComponent, {
              selectedItemList: selectedSiteList,
              onChange: (s) => {
                // console.log('Selected sites - onChange: ', s)
                selectedSiteList = s;
                filter.siteId = selectedSiteList.map(s => s.code).join('^');
                // console.log('filter.siteId: ', filter.siteId)
              }
            }),
          ),
          m('.col-12',
            m('label.form-label', this.getText("LT00000517", "Site Group(s)")),
            m(SelectSiteGroupComponent, {
              selectedItems: selectedSiteGroupList,
              onChange: (g) => {
                // console.log('Selected site groups - onChange: ', g)
                selectedSiteGroupList = g;
                filter.siteGroupId = selectedSiteGroupList.map(g => g.code).join('^');
                // console.log('filter.siteGroupId: ', filter.siteGroupId)
              }
            }),
          ),
          m('.col-12',
            m('label.form-label', this.getText("LT00000518", "User(s)")),
            m(SelectUserComponent, {
              default: {
                userStatusCode: '0001'
              },
              hideMyTeam: true,
              onSelect: (u) => {
                // console.log('Selected users - onSelect: ', u)
                selectedUserList = u;
                filter.userId = selectedUserList.map(u => u.userID).join('^');
                // console.log('filter.userId: ', filter.userId)
              },
              selectedUserList: selectedUserList,
            }),
          )
        ),
        m('.d-flex.justify-content-end.gap-3.mt-4.mb-2',
          // Download button
          m('.input-group.w-auto',
            m('button.btn.btn-primary.dropdown-toggle.dropdown-toggle-split[type=button][data-bs-toggle=dropdown][arie-expanded=false]',
              (isDownloadingExcel || isDownloadingPpt)
                ? m('span.spinner-border.spinner-border-sm.me-2[role=status][aria-hidden=true]')
                : m('i.bi.bi-file-earmark-arrow-down-fill'),
              this.getText("LT00000492", "Download")
            ),
            m('ul.dropdown-menu',
              m('li',
                m('a.dropdown-item[href="javascript:void(0);"]', {
                  class: isDownloadingExcel ? 'disabled' : '',
                  onclick: _downloadExcel
                },
                  isDownloadingExcel &&
                  m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                  this.getText("LT00000493", "Excel")
                )
              ),
              m('li',
                m('a.dropdown-item[href="javascript:void(0);"]', {
                  class: isDownloadingPpt ? 'disabled' : '',
                  onclick: _downloadPPT
                },
                  isDownloadingPpt &&
                  m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                  this.getText("LT00000494", "PPT")
                )
              ),
            ),
          ),
          m('button.btn.btn-white[type=button]', { onclick: closeModal }, this.getText("LT00000021", "Close")),
        ),
      )
    }
  }
}